import {Injectable} from '@angular/core';
import {DefaultProfile, GroupsProvider, Rights} from '@pes/ui';
import {LbpaProfile} from './lbpa-profile.constant';

@Injectable()
export class AppGroupsProvider extends GroupsProvider {

    protected readonly PROFILES: string[] = [
        DefaultProfile.VIRTUAL_USER,
        DefaultProfile.DEVELOPER,
        DefaultProfile.CIRCUIT_MANAGER,
        LbpaProfile.CONSEILLER_ADMIN,
    ];

    /**
     * Creates a new GroupsProvider instance.
     */
    constructor() {
        super();
        this.initRights();
    }

    public getRights(profile: string): string[] {
        return this.RIGHTS.get(profile) || [];
    }

    public getGroups(type: string): string[] {
        return [];
    }

    public getProfiles(): string[] {
        return this.PROFILES || [];
    }

    public canSet(userProfile: string, profile: string): boolean {
        return (profile === LbpaProfile.CONSEILLER_ADMIN)
            || (profile === DefaultProfile.CIRCUIT_MANAGER);
    }

    /**
     * Initializes the rights for the current app profiles.
     */
    protected initRights(): void {
        this.RIGHTS.set(
            DefaultProfile.DEVELOPER,
            [
                Rights.DEV,
                Rights.ALL
            ]
        );

        this.RIGHTS.set(
            DefaultProfile.VIRTUAL_USER,
            [
                Rights.CIRCUIT_READ,
                Rights.CIRCUIT_DOWNLOAD_ALL,
                Rights.CIRCUIT_DOWNLOAD_PROOF
            ]
        );
        this.RIGHTS.set(
            DefaultProfile.CIRCUIT_MANAGER,
            [
                Rights.PROFILE_MENU,
                Rights.CIRCUIT_MANAGEMENT,
                ...Rights.CIRCUIT_ALL_LIMITED,
                Rights.CIRCUIT_LIST_DIVISION,
                // Rights.DASHBOARD
            ]
        );
        this.RIGHTS.set(
            LbpaProfile.CONSEILLER_ADMIN,
            [
                // Rights.DASHBOARD,
                Rights.PROFILE_MENU,
                Rights.CIRCUIT_DELETE,
                Rights.CIRCUIT_CANCEL,
                Rights.CIRCUIT_LIST,
                Rights.CIRCUIT_LIST_ALL,
                Rights.CIRCUIT_LIST_COMPANY,
                Rights.CIRCUIT_LIST_DIVISION,
                Rights.CIRCUIT_READ,
                Rights.CIRCUIT_MANAGEMENT,
                Rights.CIRCUIT_UPDATE,
                ...Rights.CIRCUIT_DOWNLOADS
            ]
        );

        this.WEIGHTS.set(DefaultProfile.DEVELOPER, 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/config/provider/app-rights.provider.ts